Prelogin = (function (prelogin) {
    prelogin.SelectSchool = {};
    const me = prelogin.SelectSchool;

    me.init = function () {
        const $school = $('select#school');
        if (!$school.length) return;

        // Ported from select2 to Tom Select (2026-05-11) as prep for
        // Bootstrap 5. Public behavior:
        //   - type 3+ characters → async license search
        //   - pick a result → navigate to /login/<license_guid>/
        //   - dropdown opens automatically on page load
        //
        // The result JSON shape from /api/licenses/... is unchanged;
        // we declare valueField / labelField so Tom Select knows
        // which properties to use for the native <option>.

        const tomSelect = new TomSelect($school[0], {
            placeholder: 'Begin typing to choose your school.',
            valueField: 'license_guid',
            labelField: 'license_name',
            searchField: ['license_name', 'district_display_name', 'city'],

            // Tom Select equivalent of select2's minimumInputLength: 3.
            // `load` won't fire until this returns true.
            shouldLoad(query) {
                return query.length >= 3;
            },

            // Built-in AJAX loader; debounce mirrors select2's delay:250.
            load(query, callback) {
                $.ajax({
                    url: '/api/licenses/getUniqueSchoolsAndDistricts/',
                    dataType: 'json',
                    data: { q: query },
                })
                    .done((data) => {
                        // Same a11y affordance that existed pre-port:
                        // announce the result count to screen readers.
                        $('.form-group').prepend(
                            `<p class="visually-hidden" role="region" aria-live="assertive">${data.data.length} licenses found</p>`,
                        );
                        callback(data.data || []);
                    })
                    .fail(() => callback());
            },

            // Dropdown rendering. Each row shows the school name (bold)
            // with the district + city/state beneath.
            //
            // No inner <a> on the option — the select2 port used one
            // for immediate navigation, but Tom Select already fires
            // `change` on the backing <select>, which the listener
            // below turns into the /login/<guid>/ redirect. An <a>
            // inside .option also pulled the page's link color
            // (green) through the CSS cascade.
            render: {
                option(license, escape) {
                    return (
                        '<div class="school-option">'
                        + `<strong>${escape(license.license_name)}</strong>`
                        + `<small>${escape(license.district_display_name)} — ${escape(license.city)}, ${escape(license.state_code)}</small>`
                        + '</div>'
                    );
                },
                item(license, escape) {
                    return `<div>${escape(license.license_name || license.district_display_name || license.license_guid)}</div>`;
                },
            },
        });

        // Navigation: select2 fired a custom `select2:select` event.
        // Tom Select keeps the native <select>'s `change` event
        // working, so we just listen for that — simpler, library-
        // neutral, and the exact pattern every future port will use.
        $school.on('change', function onSchoolChange() {
            const guid = $(this).val();
            if (guid) {
                window.location.href = `/login/${guid}/`;
            }
        });

        // Open the dropdown on page load. select2 used .select2('open');
        // Tom Select exposes .open() directly on the instance.
        tomSelect.focus();
        tomSelect.open();
    };

    return prelogin;
}(Prelogin || {}));
